<app-pan-modal #mergeBranchModal [topLevel]="false" [isOpen]="isVisible()" (modalClose)="isVisible.set(false)">
  <div header>Merge Branch</div>

  <div body class="flex flex-col gap-2">
    <app-pan-form-control class="flex-1">
      <app-pan-floating-label>Branch</app-pan-floating-label>
      <ng-select
        [(ngModel)]="selectedBranch"
        [items]="branchChoices()"
        [loading]="isLoading()"
        [virtualScroll]="true"
        placeholder="Select branch..."
        bindLabel="name"
        bindValue="id"
        [disabled]="isLoading()"
      ></ng-select>
    </app-pan-form-control>
  </div>

  <div footer class="flex gap-2">
    <button panButton panModalClose color="default">Cancel</button>

    <button panButton panModalClose color="primary" (click)="mergeBranchSwal.fire()" [disabled]="!selectedBranch()">Merge Branch</button>
  </div>
</app-pan-modal>

<swal
  #mergeBranchSwal
  title="Merge Branch?"
  text="Are you sure you want to merge the current branch {{ currentBranch().name }} with the selected branch {{
    selectedBranchRef()?.name
  }}? This will move ALL locations into this branch: {{ selectedBranchRef()?.name }}."
  icon="warning"
  confirmButtonText="Yes, Merge"
  [showCancelButton]="true"
  [focusCancel]="true"
  (confirm)="mergeBranch()"
>
</swal>
